<template>
    <div class="action-note">
        <div class="action-note__title">
            {{ date | formatDate }} | {{ userFullName }}
        </div>
        <div class="action-note__body">
            <div v-if="label">
                {{ label }}
            </div>
            {{ note }}
        </div>
        <div class="action-note__footer">
        <div    v-for="file in files"
                :key="file.url"
               :class="'action-note__file ' + file.extension "
                v-viewer="{
                        button: false,
                        navbar: false,
                        title: false,
                        toolbar: false,
                        url: 'full-image',
                }"
            >
                <img
                    v-if="isImage(file)"
                    :src="getFileThumbnail(file)"
                    :full-image="getFileUrl(file)"
                    alt=""/>
                <a v-else
                   :href="getFileUrl(file)"
                   target="_blank"
                >
                    <font-awesome-icon
                            class="icon"
                            :icon="getFileIcon(file)">
                    </font-awesome-icon>
                </a>
                <div v-if="file.dateTaken"
                    class="meta-data">
                    <span>{{ file.dateTaken }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import riskhub from "@/services/Riskhub/Riskhub";

export default {
  name: 'Action-Note',
  props: {
    date: {},
    user: {},
    adminUser: {},
    label: {
      type: String,
    },
    note: {
      type: String,
    },
    files: {
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    userFullName() {
      const user = this.user ? this.user : this.adminUser;
      if (user) {
        return `${user.firstName} ${user.lastName}`;
      }
      return '';
    },
  },
  filters: {
    formatDate(date) {
      return riskhub.formatDateTime(date);
    },
  },
  methods: {
    getFileThumbnail(file) {
      return file.thumbnailUrl;
    },
    /**
     * Get the URL for the file
     */
    getFileUrl(file) {
      return file.url;
    },
    urlEncodeFileName(filePath) {
      let urlPathParts = filePath.split('/');
      const fileNamePathIndex = urlPathParts.length - 1;
      urlPathParts[fileNamePathIndex] = encodeURIComponent(urlPathParts[fileNamePathIndex]);
      return urlPathParts.join('/');
    },
    /**
     * Check if the file is a PDF
     * @param extension
     * @returns {boolean}
     */
    isImage({extension}) {
      return ['jpg','jpeg','png'].includes(extension);
    },
    getFileIcon({extension}) {
      let icon;
      switch (extension) {
        case 'doc':
        case 'docx':
            icon = 'file-word';
            break;

        case 'xls':
        case 'xlsx':
        case 'csv':
          icon = 'file-excel';
          break;
            
        case 'pdf':
          icon = 'file-pdf';
          break;
      }
      
      return ['fas', icon];
    },
  },
};
</script>

<style lang="scss">
    .action-note {
        border: 1px solid $border-color;
        border-radius: 3px;
        padding: 20px 22px;
        margin-bottom: 25px;
        font-size: $font-size-sm;

        &__title {
            color: $purple;
            margin-bottom: 5px;
        }

        &__body {
            margin-bottom: 15px;
        }

        &__footer {
            display: flex;
            flex-wrap: wrap;
        }

        &__file {
            width: 80px;
            min-height: 80px;
            margin-right: 25px;
            border-radius: 2px;
            overflow: hidden;

            &.pdf {
                border-radius: 2px;
                background: $red;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            &.doc, &.docx {
              border-radius: 2px;
              background: #285192;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          
            &.xls, &.xlsx, &.csv {
              border-radius: 2px;
              background: #206f44;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .icon {
                font-size: 54px;
                color: $white;
            }

            img {
                border-radius: 2px;
                cursor: pointer;
            }

            .meta-data {
                font-size: 12px;
                text-align: center;
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .fancy-box-mask {
        z-index: 1100;
    }
</style>
